<template>
    
    <div class="temp-wrap" >
        <div class="main-title">
            <h1 v-html="all_questions.questions_diamond.title"></h1>
        </div>
        <div class="bottom-list-wrap" >
            <ul class="custom-scroller">

                <li class="ways-li">
                <div class="ways-title">{{all_questions.questions_diamond.list1.title}}</div>
                <div class="all-ways">
                    <div class="way" v-for="(way, id) in all_questions.questions_diamond.list1.contents">
                    <div class="num">{{id+1}}.&nbsp</div>
                    <div class="text">{{way}}</div>
                    </div>
                </div>
                </li>


                <li class="ways-li">
                <div class="ways-title">{{all_questions.questions_diamond.list2.title}}</div>
                <div class="all-ways">
                    <div class="way" v-for="(way, id) in all_questions.questions_diamond.list2.contents" >
                    <template v-if="!(typeof(way)=='object')">
                        <div class="num">{{id+1}}.&nbsp</div>
                        <div class="text">{{way}}</div>
                    </template>
                    <template v-else>
                        <!-- {{id+1}}. {{way}} -->
                        <div class="num">{{id+1}}.&nbsp</div>
                        <div class="text">{{way.content}}</div>
                        <ol class="sub-list" type="A">
                        <li v-for="list in way.sub_list">{{list}}</li>
                        </ol>
                    </template>
                    </div>
                </div>
                </li>

                <li class="ways-li">
                <div class="ways-title">{{all_questions.questions_diamond.list3.title}}</div>
                <div class="all-ways">
                    <div class="way">{{all_questions.questions_diamond.list3.pre_content}}</div>  
                    <div class="way" v-for="(way, id) in all_questions.questions_diamond.list3.contents">
                    <div class="num">{{id+1}}.&nbsp</div>
                    <div class="text">{{way}}</div>
                    </div>
                </div>
                </li>


                <li class="ways-li">
                <div class="ways-title">{{all_questions.questions_diamond.list4.title}}</div>
                <div class="all-ways">
                    <div class="way" v-for="(way, id) in all_questions.questions_diamond.list4.contents">
                    <div class="num">{{id+1}}.&nbsp</div>
                    <div class="text">{{way}}</div>
                    </div>
                </div>
                </li>


                <li class="qa-li" v-for="q in all_questions.questions_diamond.questions">
                
                <div class="qa-div q">
                    <div class="char">Q :</div>
                    <div class="text">{{q.q}}</div>
                </div>
                <div class="qa-div">
                    <div class="char">A :</div>
                    <div class="text" v-if="!Array.isArray(q.a)">{{q.a}}</div>
                    <div class="text" v-else>
                    <ul class="inner-ul">
                        <li class="inner-li" v-for="(a, id) in q.a">{{a}}</li>
                        
                    </ul>
                    </div>
                </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import ct_scroll from './function.js'
export default {
    props: ["all_questions"],
    mounted(){
        ct_scroll();
    }

}
</script>


// WEBPACK FOOTER //
// src/Qna/diamond.vue